module.exports = __webpack_public_path__ + "files/61b7e84911498a766585c4f0f30286b1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/themes/code_themes/solarized-light.png
 ** module id = 821
 ** module chunks = 0
 **/